import { render } from "./PeerReviewView.vue?vue&type=template&id=9fabfd70"
import script from "./PeerReviewView.vue?vue&type=script&lang=js"
export * from "./PeerReviewView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__